import { SVGProps } from "react";

export function Info(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.5 3.5C14.0196 3.5 16.4359 4.50089 18.2175 6.28249C19.9991 8.06408 21 10.4804 21 13C21 15.5196 19.9991 17.9359 18.2175 19.7175C16.4359 21.4991 14.0196 22.5 11.5 22.5C8.98044 22.5 6.56408 21.4991 4.78249 19.7175C3.00089 17.9359 2 15.5196 2 13C2 10.4804 3.00089 8.06408 4.78249 6.28249C6.56408 4.50089 8.98044 3.5 11.5 3.5ZM11.5 4.5C9.24566 4.5 7.08365 5.39553 5.48959 6.98959C3.89553 8.58365 3 10.7457 3 13C3 15.2543 3.89553 17.4163 5.48959 19.0104C7.08365 20.6045 9.24566 21.5 11.5 21.5C12.6162 21.5 13.7215 21.2801 14.7528 20.853C15.7841 20.4258 16.7211 19.7997 17.5104 19.0104C18.2997 18.2211 18.9258 17.2841 19.353 16.2528C19.7801 15.2215 20 14.1162 20 13C20 10.7457 19.1045 8.58365 17.5104 6.98959C15.9163 5.39553 13.7543 4.5 11.5 4.5ZM11 8.5V10.5H12V8.5H11ZM11 12.5V17.5H12V12.5H11Z"
        fill="currentColor"
      />
    </svg>
  );
}
